import { useQuery } from '@tanstack/react-query'
import { supabase } from '../services/supabase'
import type { User } from '../types'

const fetchUserProfile = async (userId: string, email: string): Promise<User | null> => {
  const { data: profile, error: fetchError } = await supabase
    .from('profiles')
    .select('*')
    .eq('id', userId)
    .maybeSingle()

  if (fetchError) throw fetchError

  if (!profile) {
    const { data: newProfile, error: insertError } = await supabase
      .from('profiles')
      .insert([{ id: userId, email, role: 'traveler' }])
      .select()
      .single()

    if (insertError) throw insertError

    return newProfile
  }

  return profile
}

export const useProfile = (userId: string | null, email: string | null) => {
  return useQuery({
    queryKey: ['profile', userId],
    queryFn: () => fetchUserProfile(userId!, email!),
    enabled: !!userId && !!email, // Only fetch if userId and email are available
    staleTime: 1000 * 60 * 5 // Cache for 5 minutes
  })
}
